// extracted by mini-css-extract-plugin
module.exports = {"Label":"BreakpointOptions_Label__x6avM","Options":"BreakpointOptions_Options__S6jRr"};